import React, { useState } from 'react';
import AIFeedback from '@nile/components/src/Components/AI/components/AIFeedback.js';
import { withErrorBoundary } from '@nile/components';
import { useMutation } from '@apollo/client';
import { ADD_AI_AGENT_FEEDBACK } from '@nile/banyan/src/Graphql/Mutations/ai';
import { AccountClient } from '@nile/graphql';

interface TriageFeedbackProps {
  buttonVariant: string;
  onFeedbackComplete: () => void;
  featureId: string;
  sourceAction: string[];
  entity: string;
  entityId: string;
  getSuggestedFields: () => any;
}

const TriageFeedback = (props: TriageFeedbackProps) => {
  const {
    buttonVariant,
    onFeedbackComplete,
    featureId,
    sourceAction,
    entity,
    entityId,
    getSuggestedFields
  } = props;

  const [addFeedback] = useMutation(ADD_AI_AGENT_FEEDBACK, {
    client: AccountClient
  });

  const [feedbackLoading, setFeedbackLoading] = useState(false);

  const sendActivity = async (activity) => {
    const type = activity?.type;
    const feedbackComment = activity?.feedbackComment;

    let data;
    if (getSuggestedFields) {
      data = { data: getSuggestedFields() };
    }

    try {
      setFeedbackLoading(true);
      const response = await addFeedback({
        variables: {
          input: {
            aiAgent: {
              featureId
            },
            sourceAction: sourceAction,
            message: feedbackComment,
            entity: entity,
            entityId: entityId,
            data
          }
        }
      });
      if (response?.data?.addAIAgentFeedback) {
        setFeedbackLoading(false);
        onFeedbackComplete();
      }
    } catch (error) {
      console.error('Error adding feedback:', error);
      setFeedbackLoading(false);
    }
  };

  return (
    <AIFeedback
      sendActivity={sendActivity}
      hideThumbsUp
      buttonVariant={buttonVariant}
      hideFeedbackText
      hideTitle
    />
  );
};

export default withErrorBoundary(TriageFeedback);
